import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { sendResetMail } from '../actions/Users';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import './login.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      message: '',
    };
  }

  handleChange = e => {
    this.setState({ email: e.target.value.trim() });
  };

  handleSubmit = async e => {
    const { sendResetMail } = this.props;
    const { email } = this.state;
    e.preventDefault();
    try {
      await sendResetMail(email);
      localStorage.setItem('email', email);
      this.setState({
        message:
          'We sent you instructions for resetting your password. Check your email and click on the link. Or, return to the',
      });
    } catch (error) {
      this.setState({ email: '', message: error.message });
    }
  };

  handleBack = () => {
    this.setState({ message: '' });
  };

  render() {
    const { user } = this.props;
    const { message, email } = this.state;
    if (user && user._id) {
      return <Redirect to="/" />;
    }

    return (
      <div className="container main-container">
        <div className="login-container">
          <div className="col-12 align-self-start" style={{ display: 'flex' }}>
            <EpikLogoSvg width={120} height={60} />
          </div>
          <div className="col-12 text-left" style={{ marginTop: '30px' }}>
            {message ? (
              <>
                {email === '' ? (
                  message !== 'User with this email address does not exist' ? (
                    <>
                      <h5>Something wrong</h5>
                      <p style={{ color: '#8998ac' }}>
                        Check your mail, maybe a letter has already been sent to you or
                        <Link
                          style={{ color: '#3b5aa9', textDecoration: 'underline' }}
                          to="/reset-password"
                          onClick={this.handleBack}
                        >
                          {' '}
                          try again
                        </Link>{' '}
                        later or go back to{' '}
                        <Link to="/login" style={{ color: '#3b5aa9', textDecoration: 'underline' }}>
                          {' '}
                          password entry.
                        </Link>
                      </p>
                    </>
                  ) : (
                    <>
                      <h5>Email not found!</h5>
                      <p style={{ color: '#8998ac' }}>
                        <Link
                          style={{ color: '#3b5aa9', textDecoration: 'underline' }}
                          to="/reset-password"
                          onClick={this.handleBack}
                        >
                          {' '}
                          Try again{' '}
                        </Link>{' '}
                        or go back to
                        <Link style={{ color: '#3b5aa9', textDecoration: 'underline' }} to="/login">
                          {' '}
                          password entry.
                        </Link>
                      </p>
                    </>
                  )
                ) : (
                  <>
                    <h1 className="text-primary">Reset link sent</h1>
                    <p style={{ color: '#8998ac' }}>
                      {message}{' '}
                      <Link to="/login" style={{ color: '#3b5aa9', textDecoration: 'underline' }}>
                        {' '}
                        Login page.
                      </Link>
                    </p>
                  </>
                )}
              </>
            ) : (
              <>
                <h5>Reset Password</h5>
                <p style={{ color: '#8998ac' }}>
                  Please enter your email address to search for your account and we will send you an
                  email to reset your password.
                </p>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Input
                      className="input-field"
                      type="email"
                      value={email}
                      onChange={this.handleChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </FormGroup>
                  {message && <span style={{ color: '#17a2b8' }}>{message}</span>}
                  <FormGroup className="text-right">
                    <Button color="primary">Search</Button>
                    <Link to="/" style={{ marginLeft: '10px' }}>
                      <Button type="button">Cancel</Button>
                    </Link>
                  </FormGroup>
                </Form>
              </>
            )}
          </div>
          {/* <div className="col-3" style={{ margin: "auto" }}>
              <img style={{ width: "300px" }} alt="Epik" src={EpikLogo} />
            </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  sendResetMail: email => dispatch(sendResetMail(email)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);
